import React, { Fragment } from 'react';

const FormsUsage = () => (
  <Fragment>
    <section>
      <article className="flex-justify-end flex-row last">
        <div className="left">
          <h1 className="h1 page-title">Forms are used to get information and guide people with minimal fuss.</h1>
        </div>
        <div className="right">
          <p>Use forms to allow people to enter data for use by the application, or to configure options. Forms are used to get information and guide people with minimal fuss. Designing forms well requires making decisions about structure, sequence, interface elements, field labels, help, and feedback.</p>
        </div>
      </article>
    </section>
    <section className="bg-grey flex-grow-1 with-padding">
      <article className="flex-row flex-justify-end">
        <div className="right copy-content">
          <h2 className="h2 page-subtitle">Create Account Form</h2>
          <p>This form is used when the user needs to create a new account. It is divided into three sections: Form Header Section — that is composed by a title; Form Inputs Section — this is the main section, with input section titles, a text field to input the email, and a password input; Form Bottom Section — with a button to proceed and a link in case the users that are already registered.</p>

          <h2 className="h2 page-subtitle">Login Form</h2>
          <p>Similarly to the previous form, this form is also divided into three sections,  but this one is used for already registered users to log in. Form Header Section — composed by a title; Form Inputs Section — composed by input section titles, a text field for the email, password input, and a check-box; Form Bottom Section — composed by a button, main and secondary link.</p>

          <h2 className="h2 page-subtitle">Credit Card Form</h2>
          <p>As suggested by the name, this form is used to insert credit cards information and it is divided into two sections: Form Inputs Sections — where you can see a text field to enter the name on the card, card number input, expire date input and security code input; Form Bottom Section — where you can find a cancel link and a button to proceed.</p>

          <h2 className="h2 page-subtitle">Wizard Form</h2>
          <p>This form is composed of several inputs divided into steps. It should be used when the user wants to accomplish a goal that has many steps that must be completed in a specific sequence. When using it, is best to keep the number of steps to a minimum and avoid heavy chunks of information in each step.</p>

          <h2 className="h2 page-subtitle">Suggestion Box</h2>
          <p>A suggestion box is a custom form with bigger sizes and bright colours to fit the need to grasp the attention of the user since it is usually an optional form.</p>

          <h2 className="h2 page-subtitle">Costum Forms</h2>
          <p>When there is the need to create a custom form, apart from the documented distances, some rules should be followed: they can be made up from different elements and its arrangement is flexible; it can have one or two columns, depending on the page layout; they should be short, if they are too complex consider using wizard; forms should follow a logical order and be divided into sections; instead of pointing out the required fields, highlight the one that are optional.</p>
        </div>
      </article>
    </section>
  </Fragment>
);

export default FormsUsage;



// WEBPACK FOOTER //
// ./src/containers/components/Form/FormsUsage.js